/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {message, Tree} from 'antd'
import cookie from 'react-cookies'
import {Link} from 'react-router-dom'
import 'react-checkbox-tree/lib/react-checkbox-tree.css'
import CheckboxTree from 'react-checkbox-tree'
import SECURITY from '../BaseComponent/SECURITY'
const {TreeNode} = Tree

class AddRole extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      permission: [],
      checked: [],
      expanded: [],
      list: [],
      expandedKeys: [],
      autoExpandParent: true,
      checkedKeys: [],
      selectedKeys: [],
      parent: [],
      error: '',
      cats: []
    }
    this.onCheck = this.onCheck.bind(this)
    this.onExpand = this.onExpand.bind(this)
  }

  componentDidMount() {
    http.get(`${SECURITY.SECURITY_MANAGE_LIST_ROLECATEGORY}`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          cats: response.data.object
        })
      } else {
        // message.error(response.data.description)
      }
    })

    http.get(`${SECURITY.SECURITY_MANAGE_LIST_PERMISSION}`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          permission: response.data.object.tree,
          list: response.data.object.list,
          parent: response.data.object.parent
        })
      } else {
        // message.error(response.data.description)
      }
    })
  }

  // onCheck(checked,targetNode) {
  //     this.setState({ checked });
  //     // if(targetNode.checked){
  //     //     console.log(targetNode)
  //     //     //
  //     //     // for(let i=0;i<targetNode.children.length;i++){
  //     //     //     this.f(targetNode.children[i])
  //     //     // }
  //     //
  //     //
  //     //     // let {list}=this.state;
  //     //     //
  //     //     //
  //     //     //
  //     //     // for(let i=0;i<list.length;i++){
  //     //     //     if(targetNode.value===list[i].id){
  //     //     //         if(list[i].traversal==false){
  //     //     //             // alert(JSON.stringify(targetNode.children))
  //     //     //         }
  //     //     //     }
  //     //     // }
  //     // }
  //
  // }

  // onExpand(expanded) {
  //     this.setState({ expanded });
  // }

  onExpand = (expandedKeys) => {
    console.log('onExpand', expandedKeys)
    // if not set autoExpandParent to false, if children expanded, parent can not collapse.
    // or, you can remove all expanded children keys.
    this.setState({
      expandedKeys,
      autoExpandParent: false
    })
  }

  // onCheck = (checkedKeys,event) => {
  //     if(event.checked) {
  //         let prevKeys=this.state.checkedKeys;
  //         var checked=checkedKeys;
  //         let difference = checked.filter(x => !prevKeys.includes(x));
  //
  //         let {parent, list}=this.state;
  //         var selfKey=event.node.props.eventKey;
  //         var parentKeys=parent[selfKey];
  //
  //         checked = checked.filter(x => !parentKeys.includes(x));
  //         difference = difference.filter(x => !parentKeys.includes(x));
  //         checked = checked.filter(x => x !== selfKey);
  //         difference = difference.filter(x => x !== selfKey);
  //
  //         for(let i=0;i<difference.length;i++) {
  //             for(let j=0;j<list.length;j++) {
  //                 if (difference[i] === list[j].id.toString() && list[j].traversal === false) {
  //                     checked = checked.filter(x => x !== difference[i]);
  //                 }
  //             }
  //         }
  //         checkedKeys = checked;
  //     }
  //     this.setState({ checkedKeys:checkedKeys });
  // }

  onCheck = (checkedKeys, event) => {
    if (event.checked && !event.isLeaf) {
      let prevKeys = this.state.checkedKeys
      var checked = checkedKeys
      let difference = checked.filter((x) => !prevKeys.includes(x))

      let {parent, list} = this.state
      var selfKey = event.value
      var parentKeys = parent[selfKey]

      checked = checked.filter((x) => !parentKeys.includes(x))
      difference = difference.filter((x) => !parentKeys.includes(x))
      checked = checked.filter((x) => x !== selfKey)
      difference = difference.filter((x) => x !== selfKey)

      for (let i = 0; i < difference.length; i++) {
        for (let j = 0; j < list.length; j++) {
          if (difference[i] === list[j].id.toString() && list[j].traversal === false) {
            checked = checked.filter((x) => x !== difference[i])
          }
        }
      }
      checkedKeys = checked
    }
    this.setState({checkedKeys: checkedKeys})
  }

  onSelect = (selectedKeys, info) => {
    console.log('onSelect', info)
    this.setState({selectedKeys})
  }

  renderTreeNodes = (data) =>
    data.map((item) => {
      if (item.children) {
        return (
          <TreeNode title={item.title} key={item.key} dataRef={item} traversal={item.traversal}>
            {this.renderTreeNodes(item.children)}
          </TreeNode>
        )
      }
      return <TreeNode {...item} />
    })

  submit(e) {
    e.preventDefault()
  }
  addPermission() {
    let {checkedKeys} = this.state
    var title = document.getElementById('title').value
    var category = document.getElementById('category').value
    var manageView = document.getElementById('manageView').value
    var errorForm = false
    var titleError = false
    var catError = false
    var manageViewError = false
    var rolesError = false
    if (title == '') {
      titleError = true
      errorForm = true
      message.error('عنوان را وارد کنید')
    } else {
      if (!titleError) {
        this.setState({
          error: ''
        })
      }
    }
    if (category == '') {
      catError = true
      errorForm = true
      message.error('گروه را مشخص کنید')
    } else {
      if (!catError) {
        this.setState({
          error: ''
        })
      }
    }
    if (manageView == '') {
      manageViewError = true
      errorForm = true
      message.error('مشاهده پنل مدیریت را تعیین کنید')
    } else {
      if (!manageViewError) {
        this.setState({
          error: ''
        })
      }
    }
    if (checkedKeys.length == '0') {
      rolesError = true
      errorForm = true
      message.error('حداقل یک دسترسی انتخاب کنید')
    } else {
      if (!rolesError) {
        this.setState({
          error: ''
        })
      }
    }
    if (!errorForm) {
      for (let i = 0; i < checkedKeys.length; i++) {
        checkedKeys[i] = Number(checkedKeys[i])
      }

      let data = {
        title: title,
        category: category,
        manageView: manageView,
        permissionIds: checkedKeys
      }
      http
        .post(`${SECURITY.SECURITY_MANAGE_ADD_ROLE}`, data, {})
        .then((response) => {
          if (response.data.error == null) {
            message.success('دسترسی با موفقیت اضافه شد.لطفا صبر کنید')
            setInterval(() => {
              window.location.assign('/roles')
            }, 2000)
          } else {
            // message.error(response.data.description)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  render() {
    const {checked, expanded} = this.state

    return (
      <div className="rtl">
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>کاربران</li>
            <li>ثبت سطح دسترسی</li>
          </ul>

          {/*<Tree*/}
          {/*checkable*/}
          {/*onExpand={this.onExpand}*/}
          {/*expandedKeys={this.state.expandedKeys}*/}
          {/*autoExpandParent={this.state.autoExpandParent}*/}
          {/*onCheck={this.onCheck}*/}
          {/*checkedKeys={this.state.checkedKeys}*/}
          {/*onSelect={this.onSelect}*/}
          {/*selectedKeys={this.state.selectedKeys}*/}
          {/*>*/}
          {/*{this.renderTreeNodes(this.state.permission)}*/}
          {/*</Tree>*/}

          <form className="horizontalForm" onSubmit={this.submit.bind(this)}>
            <div className="formComponent">
              <label>
                عنوان <span className="requireFiled">*</span>
              </label>
              <input type="text" id="title" className="form-control" />
            </div>
            <div className="formComponent">
              <label>
                گروه <span className="requireFiled">*</span>
              </label>
              <select className="form-control" name="category" id="category">
                <option value="">------</option>
                {this.state.cats.map((cat, index) => (
                  <option value={cat.id}>{cat.title}</option>
                ))}
              </select>
            </div>
            <div className="formComponent">
              <label>
                مشاهده پنل مدیریت <span className="requireFiled">*</span>
              </label>
              <select className="form-control" name="manageView" id="manageView">
                <option value="">------</option>
                <option value={1}>بله</option>
                <option value={0}>خیر</option>
              </select>
            </div>
            <div className="formComponent">
              <br />
              <button className="btn btn-info btn-block form-control" onClick={this.addPermission.bind(this)}>
                ثبت سطح دسترسی
              </button>
            </div>
          </form>
          <CheckboxTree
            nodes={this.state.permission}
            checked={this.state.checkedKeys}
            expanded={this.state.expanded}
            onCheck={this.onCheck}
            onExpand={(expanded) => this.setState({expanded})}
            optimisticToggle={false}
          />
        </div>
      </div>
    )
  }
}
export default AddRole
